module.exports = __webpack_public_path__ + "img/home.07f1db6e.png";